import React, { Component } from 'react';
import withRouter from '../../withRouter';
import { connect } from 'react-redux';
class AnnouncementBanner extends Component {

    constructor(props) {
        super(props);
    }

    truncateText(text, maxLength = 300) {
        if(!text) return '';
        if (text?.length <= maxLength) return text;
        return text.slice(0, maxLength) + '...';
    }

    render() {
        const isEnabled = this.props.isBannerEnable;
        const bannerContent = this.truncateText(this.props.bannerContent?.trim(), 300);

        if (!isEnabled || !bannerContent) {
            return null;
        }

        return (
            <div className="banner-content">
                <span className="banner-text" dangerouslySetInnerHTML={{ __html: bannerContent }} />
            </div>
        );
    }
}

export const mapStateToProps = (state) => {
    return {
        isBannerEnable: state.dataStore.isBannerEnable,
        bannerContent: state.dataStore.bannerContent,
    };
};

export const mapDispatchToProps = (dispatch) => {
    return {
        setIsBannerEnable: (value) => {
            return dispatch({
                type: 'SET_BANNER_ENABLE',
                value: value
            });
        },
        setBannerContent: (value) => {
            return dispatch({
                type: 'SET_BANNER_CONTENT',
                value: value
            })
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnnouncementBanner));
